<script setup>
import { ref, computed } from "vue";
import { useForm } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';
import PageHeader from '@/Components/PageHeader.vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Link, Head } from '@inertiajs/inertia-vue3';
import TableResponsive from "@/Components/TableResponsive.vue";
import { Icon } from "@iconify/vue";
import Buttons from "@/Components/Buttons.vue";
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BreezeInput from '@/Components/Input.vue';
import BreezeLabel from '@/Components/Label.vue';
const props = defineProps({
    objects: Array,
    modulo: String,
    rutaprefijo: String,
    title: String,
    isRef: Boolean,
    select1: Array,
    select2: Array,
    select3: Array,
    nostatus: Boolean,
    deleteable: Boolean
});

const mapOptionsLocal = (obj) => {
    if (!obj) return undefined;
    if (Object.keys(obj).length === 0) return undefined;
    if (Array.isArray(obj)) return obj.map(o => ({ value: isNaN(o.value) ? o.value : Number(o.value), label: o.label }));
    return Object.entries(obj).map(([key, value]) => ({
        value: isNaN(key) ? key : Number(key),
        label: value
    }));
};

const typeOptions = { 'string': 'Texto', 'number': 'Número', 'sino': 'SiNo', 'date': 'Fecha', 'html': 'Html' };
const visibilityOptions = { 0: 'Oculto', 1: 'Visible' };

const columnas = computed(() => {
    if (props.modulo === 'constante') {
        return [
            { key: 'actions', label: 'Acciones', align: 'center', hideLabel: true },
            { key: 'name', label: 'Nombre', filterType: 'text', maxLength: 25, standout: true },
            ...(props.nostatus ? [] : [{ key: 'position', label: 'Posición', align: 'center' }]),
            ...(props.nostatus ? [] : [{ key: 'type', label: 'Tipo', filterType: 'select', filterOptions: mapOptionsLocal(typeOptions), align: 'center' }]),
            { key: 'value', label: 'Valor', maxLength: 25 },
            { key: 'note', label: 'Descripción', maxLength: 40, stacked: true },
            { key: 'name_user', label: 'Modificado por', },
            { key: 'updated_at', label: 'Modificado el', align: 'center', filterType: 'date' },
            ...(props.nostatus ? [] : [{ key: 'visible', label: 'Visible', filterType: 'select', filterOptions: mapOptionsLocal(visibilityOptions), filterColor: [{ value: 0, color: 'red' }, { value: 1, color: 'green' }], align: 'center', nowrap: true }])
        ];
    }
    // Fallback básico para otros módulos
    return [
        { key: 'actions', label: 'Acciones', align: 'center' },
        { key: 'label', label: 'Nombre', filterType: 'text' }
    ];
});

const isModalActive = ref(false);
const isModalDangerActive = ref(false);
const isErrorForm = ref(false);
const rowID = ref(0);
const rowAction = ref('');

const form = useForm({
    name: '',
    note: '',
    type: '',
    position: 0,
    value: '',
    visible: 0
});

const initModal = (item, action) => {
    isErrorForm.value = false;
    rowAction.value = action;
    
    if (action === 'registrar') {
        form.reset();
        isModalActive.value = true;
    } else if (action === 'actualizar') {
        rowID.value = item.id;
        form.name = item.name;
        form.note = item.note;
        form.type = item.type;
        form.position = item.position;
        form.value = item.value;
        form.visible = item.visible;
        isModalActive.value = true;
    } else if (action === 'eliminar') {
        rowID.value = item.id;
        isModalDangerActive.value = true;
    }
};

const isConfirm = () => {
    const ruta = props.rutaprefijo + '-' + rowAction.value;
    
    if (rowAction.value === 'registrar') {
        if (!form.name || !form.type || !form.note) {
            isModalActive.value = true;
            isErrorForm.value = true;
        } else {
            Inertia.post(route(ruta, form.data()), {
                onSuccess: () => { isModalActive.value = false; form.reset(); }
            });
        }
    } else if (rowAction.value === 'actualizar') {
        if (!form.name || !form.type || !form.note) {
            isModalActive.value = true;
            isErrorForm.value = true;
        } else {
            Inertia.put(route(ruta, { id: rowID.value, ...form.data() }), {
                onSuccess: () => { isModalActive.value = false; form.reset(); }
            });
        }
    } else if (rowAction.value === 'eliminar') {
        Inertia.put(route(ruta, { id: rowID.value }), {
            onSuccess: () => { isModalDangerActive.value = false; }
        });
    }
};

const isCancel = () => {
    isModalActive.value = false;
    isModalDangerActive.value = false;
    form.reset();
};

/* const rutaprefijo = ref('parentesco');
const modulo = ref('parentesco'); */
</script>

<template>

    <Head title="Catálogo Config." />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader :title="title">
                <template #actions v-if="modulo === 'constante'">
                    <Buttons color="blue" icon="tabler:plus" size="sm" label="Nuevo" @click.prevent="initModal(null, 'registrar')" />
                </template>
            </PageHeader>
        </template>

        <div class="py-8 lg:py-10">
            <div class="sm:px-6 lg:px-8 px-4 mx-auto">
                <div class="grid grid-cols-4 gap-4 bg-white rounded-md overflow-hidden shadow-lg border">

                    <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                    <div class="col-span-4 p-4">
                        <TableResponsive :items="objects.data ? objects.data : objects" :headers="columnas" :spaced="true" :simpleSearch="true" title="Listado de Constantes" :showPageNumbers="false">
                            <template #cell-actions="{ item }">
                                <div class="flex gap-1 justify-center">
                                    <Buttons size="iconSm" color="yellow" title="Editar" @click.prevent="initModal(item, 'actualizar')">
                                        <Icon icon="tabler:pencil" class="text-white" />
                                    </Buttons>
                                    <Buttons size="iconSm" color="red" title="Eliminar" @click.prevent="initModal(item, 'eliminar')">
                                        <Icon icon="tabler:x" class="text-white" />
                                    </Buttons>
                                </div>
                            </template>
                            <template #cell-visible="{ item }">
                                <span v-if="item.visible" class="px-2 py-1 bg-[#10b981] text-white rounded text-xs font-semibold">Visible</span>
                                <span v-else class="px-2 py-1 bg-gray-500 text-white rounded text-xs font-semibold">Oculto</span>
                            </template>
                            <template #cell-updated_at="{ item }">
                                {{ item.updated_at ? new Date(item.updated_at).toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '' }}
                            </template>
                        </TableResponsive>
                    </div>



                </div>
            </div>
        </div>

        <!-- Modals for Constantes -->
        <CardBoxModal v-if="modulo === 'constante'" v-model="isModalActive" hasCancel :title="(rowAction === 'registrar' ? 'Registrar' : 'Actualizar') + ' constante'" @confirm="isConfirm" @cancel="isCancel">
            <div v-if="isErrorForm" class="mb-4">
                <div class="font-medium text-red-600">Ups! Debe registrar los campos requeridos *</div>
            </div>
            
            <div class="mb-3">
                <BreezeLabel for="name" value="Codigo" :required="true" />
                <BreezeInput id="name" type="text" class="mt-1 block w-full" v-model="form.name" required autocomplete="name" :readOnly="nostatus" />
            </div>
            <div class="mb-3">
                <BreezeLabel for="description" value="Descripción" :required="true" />
                <BreezeInput id="note" type="text" class="mt-1 block w-full" v-model="form.note" required autocomplete="note" :readOnly="nostatus" />
            </div>
            <div v-if="!nostatus" class="mb-3">
                <BreezeLabel for="type" value="Tipo" :required="true" />
                <select v-model="form.type" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
                    <option value="" disabled selected></option>
                    <option value="string">Texto</option>
                    <option value="number">Número</option>
                    <option value="sino">SiNo</option>
                    <option value="date">Fecha</option>
                    <option value="html">Html</option>
                </select>
            </div>
            <div v-if="!nostatus && rowAction !== 'actualizar'" class="mb-3">
                <BreezeLabel for="visible" value="Visible" :required="true" />
                <select v-model="form.visible" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
                    <option value="0">No</option>
                    <option value="1">Si</option>
                </select>
            </div>
            <div v-if="!nostatus" class="mb-3">
                <BreezeLabel for="position" value="Posición" />
                <BreezeInput id="position" type="number" class="mt-1 block w-full" v-model="form.position" required autocomplete="position" />
            </div>
            <div class="mb-3">
                <BreezeLabel for="Valor" value="Valor" :required="true" />
                <select v-if="form.type === 'sino'" v-model="form.value" required class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full">
                    <option value="0">No</option>
                    <option value="1">Si</option>
                </select>
                <BreezeInput v-else-if="form.type === 'number'" id="value_num" type="number" class="mt-1 block w-full" v-model="form.value" required autocomplete="value" />
                <BreezeInput v-else-if="form.type === 'date'" id="value_date" type="date" class="mt-1 block w-full" v-model="form.value" required autocomplete="value" />
                <textarea v-else rows="4" id="value" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full" v-model="form.value" required autocomplete="value" />
            </div>
        </CardBoxModal>
        
        <CardBoxModal v-if="modulo === 'constante'" v-model="isModalDangerActive" title="Por Confirmar" button="danger" hasCancel @confirm="isConfirm" @cancel="isCancel">
            <p>¿Está seguro de <b>{{ rowAction }}</b></p>
            <p>este registro?</p>
        </CardBoxModal>

    </BreezeAuthenticatedLayout>
</template>
